<template>
    <div id="navigation">
    <div class="navigation-container">
      <img src="../assets/relaxy-icon.svg" alt="" class="logo hide-desktop">
      <img src="../assets/relaxY-logo-text-blue.png" alt="" class="logo hide-mobile">
      <div class="menu">
        <div>
          <img src="../assets/menu-icon.svg" class="menu-icon hide-desktop" v-on:click="showMobileMenu = !showMobileMenu">
          <div class="menu-items" v-bind:class="{ showmenu: showMobileMenu }">
            <a href="#how-it-works" class="menu-item">How does it work?</a>
            <a href="#footer" class="menu-item">Contact us</a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      showMobileMenu: true,
    };
  },
  methods: {},
};

</script>

<style>


#navigation {
  height: 60px;
  width: 100%;
  z-index: 1;
  position: absolute;
}
.navigation-container {
  max-width: 1440px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;

}

.menu {
  right: 0;
  position: absolute;
  margin-right: 10px;
}

.menu-icon {
  height: 30px;
  cursor: pointer;
}

.menu-items {
  position: fixed;
  right: 10px;
  display: flex;
  flex-direction: column;
  z-index: 1;
  background-color: #fff;
}

.showmenu {
  display: none;
}

.menu-item {
  display: inline;
  padding: 14px 20px 14px 20px;
  color: #64797E;
}



.logo {
  max-height: 35px;
}

.hide-desktop {
  display: block;
}

.hide-mobile {
  display: none;
}



@media only screen and (min-width: 1440px) {

  #navigation {
    height: 100px;
  }
  .menu {
  margin-right: 0px;
  }
  .hide-desktop {
    display: none;
  }

  .hide-mobile {
    display: block;
  }

  .logo {
    max-height: 3 0px;
    
  }

  .menu-items {
    position: inherit;
    display: inline;
    background-color: transparent;
  }
  .menu-item:last-child {
    padding-right: 0;
  }

  .navigation-container {
    justify-content: unset;
  }

}


</style>